<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Oficinas</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'BrandListOffices' }">Clientes por oficinas</b-link> &raquo; <b-link :href="'/clients-by-offices/brand/'+this.$route.params.slug">Lista de Oficinas</b-link>
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <b-form @submit="onSubmit">
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Nombre">
                  <b-form-input id="name" :state="state" v-model.trim="office.name"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Dirección">
                  <b-form-input id="address" :state="state" v-model.trim="office.address"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Teléfono">
                  <b-form-input id="phone" :state="state" v-model.trim="office.phone"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Department">
                    <b-form-input id="department" :state="state" v-model.trim="office.department"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="District">
                    <b-form-input id="district" :state="state" v-model.trim="office.district"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Código SAP">
                    <b-form-input id="department" :state="state" v-model.trim="office.codigo_sap"></b-form-input>
                </b-form-group>

                <b-form-group id="fieldsetHorizontal4"
                              horizontal
                              :label-cols="12"
                              breakpoint="md"
                              label="Seleccionar Marca(s)">
                      <!--div class="form-group" :class="{'has-error': errors.has('brand') }" >
                        <b-form-select id="brand" :state="state" v-model.trim="register.brand" v-validate="'required'" name="brand" :options="brands"></b-form-select>
                        <span v-show="errors.has('brand')" class="help is-danger">Seleccione una marca</span>
                      </div-->
                      <!-- Checkboxes -->
                      <div class="form-group container" :class="{'has-error': errors.has('brand') }" >
                        <div class="row">
                          <div class="col-sm-6 check-box-marca" v-for="brand in brands" :key="brand.value">
                            <b-form-checkbox :id="brand.text" :value="brand.value" name="brand" v-model="items.checks" >
                            </b-form-checkbox>
                            <label for="brands">{{ brand.value }} </label>
                          </div>
                        </div>
                      </div>
                      <div v-for="(error, index) of errors" :key="index">
                        <b-alert show>{{error.message}}</b-alert>
                      </div>
                    </b-form-group>
                <b-button type="submit" variant="primary derco">Guardar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header'
import Menu from './Menu'
String.prototype.strip = function() {
  var translate_re = /[öäüÖÄÜßËë ]/g;
  var translate = {
    "ä":"a", "ö":"o", "ü":"u", "Ë":"e", "Ë":"e",
    "Ä":"A", "Ö":"O", "Ü":"U",
    " ":"-", "ß":"ss"
  };
    return (this.replace(translate_re, function(match){
        return translate[match];})
    );
};
export default {
  name: "CreateOffice",
  components:{
    Header,
    Menu
  },
  data() {
    return {
      office: {
        brand: null,
        slug: null,
        status: 1,
        brands: [],
      },
      brand: {},
      brands: [],
      arrayBrands: [],
      items: {
        checks:[

        ]
      }
    }
  },
  created(){
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios
        .get(`/brand`)
        .then(response => {
          for(var i=0; i<response.data.length; i++){
            var item = { value: response.data[i].name, text: response.data[i].name }
            this.brands.push(item)
            this.arrayBrands.push(response.data[i])
          }
        })
        .catch(e => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Login"
            })
          }
        });
      axios.get(`/brand/slug/` + this.$route.params.slug)
      .then(response => {
        this.brand = response.data
        document.title = "Administración Derco - Brand " + response.data[0].name
        this.office.brand = response.data[0].name
        this.office.slug = response.data[0].slug
      })
      .catch(e => {
        this.errors.push(e)
        if(e.response.status === 401) {
          this.$router.push({
            name: 'Login'
          })
        }
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let brands_selected = this.items.checks.toString();
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      let brandPost = brands_selected.split(',');
      brandPost.forEach(e => {
        let newBrand = this.arrayBrands.find(b => b.name == e)
        if (newBrand){
          this.office.brands.push({name: newBrand.name, slug: newBrand.slug});
        }
      })
      axios
        .post(`/office`, this.office)
        .then(response => {
          this.$router.push({
            name: "ShowOffice",
            params: { id: response.data._id, slug: this.$route.params.slug }
          })
        })
        .catch(e => {
          this.errors.push(e);
        })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
};
</script>
<style>
.is-danger{
  color: red;
  font-family: 'Quicksand-Regular';
  font-size: 12px;
}
.has-error{
  text-align: left;
}
h2{
  font-family: 'Quicksand-Bold';
  font-size: 26px;
  margin: 0 0 30px 0!important;
}

.custom-control-label:after, .custom-control-label:before{
  top:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateOffice.vue